
import { defineComponent } from 'vue';
import { useI18n } from 'vue-i18n';

export default defineComponent({
  name: 'DrilldownBanner',

  props: {
    name: { type: String, required: true },
    icon: { type: String, default: null },
  },

  emits: ['back'],

  setup() {
    const { t } = useI18n();
    return { t };
  },
});
